//
// Display alter style messages to the user.
//

import React from "react";
import { message } from 'antd';

import './Message.less';

const duration = 5;

/**
 * Display s success message using Antd's message system
 * @param text
 */
export const displaySuccess = (text: string): void => {
  message.success(<div className="message-content message-content-success">{text}</div>, duration).then();
}

/**
 * Display an informational message using Antd's message system
 * @param text
 */
export const displayInfo = (text: string): void => {
  message.info(<div className="message-content message-content-info">{text}</div>, duration).then();
}

/**
 * Display an error message using Antd's message system
 * @param text
 */
export const displayError = (text: string): void => {
  message.error(<div className="message-content message-content-error">{text}</div>, duration).then();
}
